import React, { Fragment, Suspense } from "react";

// Redux
import { connect } from "react-redux";
import { getRouterParams, getError } from "../../store/selectors";
import { goToRoute } from "../../store/actions";

// Components
import SuspenseLoader from "../../components/SuspenseLoader/SuspenseLoader";

// Pages
const DomainSearch = React.lazy(() => import("../DomainSearch/DomainSearch"));
const Packages = React.lazy(() => import("../Packages/Packages"));
const Cart = React.lazy(() => import("../Cart/Cart"));
const VPS = React.lazy(() => import("../VPS/VPS"));
const CustomerInfo = React.lazy(() => import("../CustomerInfo/CustomerInfo"));
const Payment = React.lazy(() => import("../Payment/Payment"));
const OrderConfirmation = React.lazy(
  () => import("../OrderConfirmation/OrderConfirmation"),
);
const ErrorNotification = React.lazy(
  () => import("../../components/ErrorNotification/ErrorNotification"),
);
const ModalView = React.lazy(() => import("../../views/ModalView/ModalView"));

function App({ routerParams, error }) {
  const pages = {
    domainSearch: {
      content: (
        <Suspense fallback={<SuspenseLoader />}>
          <DomainSearch />
        </Suspense>
      ),
    },
    addExtras: {
      content: (
        <Suspense fallback={<SuspenseLoader />}>
          <Packages />
        </Suspense>
      ),
    },
    cart: {
      content: (
        <Suspense fallback={<SuspenseLoader />}>
          <Cart />
        </Suspense>
      ),
    },
    customerDetails: {
      content: (
        <Suspense fallback={<SuspenseLoader />}>
          <CustomerInfo />
        </Suspense>
      ),
    },
    vps: {
      content: (
        <Suspense fallback={<SuspenseLoader />}>
          <VPS />
        </Suspense>
      ),
    },
    payment: {
      content: (
        <Suspense fallback={<SuspenseLoader />}>
          <Payment />
        </Suspense>
      ),
    },
    confirmation: {
      content: (
        <Suspense fallback={<SuspenseLoader />}>
          <OrderConfirmation />
        </Suspense>
      ),
    },
  };

  const pageName = routerParams.pageName;

  if (pages[pageName]) {
    const { content } = pages[pageName];

    return (
      <Fragment>
        <Suspense fallback={<></>}>
          {error && <ErrorNotification error={error} isError />}
        </Suspense>
        <Suspense fallback={<></>}>
          <ModalView />
        </Suspense>
        {content}
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <h1>Unknown error</h1>
      </Fragment>
    );
  }
}

export default connect(
  (state) => ({
    routerParams: getRouterParams(state),
    error: getError(state),
  }),
  {
    goToRouteAction: goToRoute,
  },
)(App);
